import type { GetConnectedIntegrationsResponse } from '@weft/api-definition';
import type { IntegrationProviders } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import type { CustomUseQueryOptions } from './requests/requests-types/custom-use-query-options';
import { useConnectedIntegrations } from './requests/use-integrations';

export function useActivatedIntegration(provider: IntegrationProviders, options?: CustomUseQueryOptions<GetConnectedIntegrationsResponse>) {
  const { data: connectedIntegrations } = useConnectedIntegrations(options);

  return isNotNullOrUndefined(connectedIntegrations) && connectedIntegrations.includes(provider);
} 